import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors"; // Store Custom Code
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo"; // Store Custom Code
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { AttributeValueFacetModel, FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule"; // Store Custom Code
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";
import ProductListFiltersAccordionSection, {
    ProductListFilterAccordionSectionStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import AddAttributeValueFiltersIfNotExist from "@store/Handlers/AddAttributeValueFiltersIfNotExist";
import usePrevious from "@store/Hooks/UsePrevious"; // Store Custom Code
import { getCurrentShipToState } from "@store/Selectors/ShipTos/ShipTosSelectors"; // Store Custom Code
import React, { FC, useEffect, useState } from "react"; // Store Custom Code
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
    location: getLocation(state), // Store Custom Code
    productListIsLoading: state.pages.productList.isLoading, // Store Custom Code
    currentShipTo: getCurrentShipToState(state), // Store Custom Code
    userName: state.context.session?.userName, // Store Custom Code
    isGuest: state.context.session?.isGuest, // Store Custom Code
    productListStateData: state.pages.productList,
    session: state.context.session, // Store Custom Code
});

const mapDispatchToProps = {
    addProductFilters,
    AddAttributeValueFiltersIfNotExist,
    removeProductFilters,
    loadCurrentShipTo, // Store Custom Code
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const productListAttributeFiltersStyles: ProductListFilterAccordionSectionStyles = {};

const ProductListAttributeFilters: FC<Props> = ({
    attributeTypeFacets,
    addProductFilters,
    AddAttributeValueFiltersIfNotExist,
    removeProductFilters,
    loadCurrentShipTo, // Store Custom Code
    fields,
    location, // Store Custom Code
    currentShipTo, // Store Custom Code
    userName, // Store Custom Code
    isGuest, // Store Custom Code
    productListStateData, // Store Custom Code
    session, // Store Custom Code
}) => {
    // TODO ISC-11787 - make showMoreLimit configurable
    const showMoreLimit = 10;

    // Store Custom Code START
    const previousLocation = `${usePrevious(location.pathname + location.search)}`;
    const loggedOut = !userName && !isGuest;
    const [attributeTypeFacetsSet, setattributeTypeFacetsSet] = useState(0);

    const isAuthenticated = session && session.isAuthenticated && !session.rememberMe && !session.isGuest;
    if (isAuthenticated && !currentShipTo) {
        loadCurrentShipTo();
    }

    const findMarketFacet = (facetName: string) => {
        const userMarket = currentShipTo?.properties?.customerMarket;
        let marketAttributeValue: AttributeValueFacetModel | undefined;
        if (userMarket) {
            attributeTypeFacets?.forEach(element => {
                if (element.name.toLowerCase() === facetName.toLowerCase()) {
                    marketAttributeValue = element.attributeValueFacets?.find(facet => {
                        return facet.value.toLowerCase() === userMarket.toLowerCase();
                    });
                }
            });
        }
        return marketAttributeValue;
    };

    const forceSelectionOfMarketFacetByUserData = () => {
        const marketFacet = findMarketFacet(translate("Market"));
        if (marketFacet) {
            if (!location.search.includes(marketFacet.attributeValueId)) {
                AddAttributeValueFiltersIfNotExist({ attributeValueIds: [marketFacet.attributeValueId] });
            }
        }
    };

    // Store Custom Code: Autoselect the current market
    useEffect(() => {
        if (!productListStateData.isLoading) {
            const marketFacet = findMarketFacet(translate("Market"));
            if (marketFacet) {
                if (!location.search.includes(marketFacet.attributeValueId)) {
                    const lastParams = productListStateData.lastParameter;
                    const currentParams = productListStateData.parameter;
                    const isSearch = productListStateData.isSearchPage;
                    let canFilterByMarket = false;
                    // First load of the page via browser
                    if (!lastParams) {
                        AddAttributeValueFiltersIfNotExist({ attributeValueIds: [marketFacet.attributeValueId] });
                        return;
                    }

                    if (isSearch) {
                        // Second load via router to a different search page
                        if (lastParams?.search !== currentParams?.search) {
                            canFilterByMarket = true;
                        }
                        // Navigating to a new page of same category
                        if (lastParams?.search === currentParams?.search && lastParams?.page !== currentParams?.page) {
                            canFilterByMarket = false;
                        }
                    } else {
                        // Second load via router to a different page
                        if (lastParams?.categoryId !== currentParams?.categoryId) {
                            canFilterByMarket = true;
                        }
                        // Navigating to a new page of same category
                        if (
                            lastParams?.categoryId === currentParams?.categoryId &&
                            lastParams?.page !== currentParams?.page
                        ) {
                            canFilterByMarket = false;
                        }
                    }

                    if (canFilterByMarket) {
                        AddAttributeValueFiltersIfNotExist({ attributeValueIds: [marketFacet.attributeValueId] });
                    }
                }
            }
        }
    }, [productListStateData.isLoading]);
    // Store Custom Code END

    const onChangeFacet = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ attributeValueIds: [facet.id] });
        } else {
            addProductFilters({ attributeValueIds: [facet.id] });
        }
    };

    // Store Custom Code: Automatically check the "market" facet
    if (!attributeTypeFacets?.length) {
        return <></>;
    }
    return (
        <>
            {attributeTypeFacets.map((a, i) =>
                a.attributeValueFacets ? (
                    <ProductListFiltersAccordionSection
                        key={a.attributeTypeId}
                        title={a.nameDisplay}
                        facets={a.attributeValueFacets.map<FacetModel>(av => ({
                            ...av,
                            id: av.attributeValueId,
                            name: av.valueDisplay,
                        }))}
                        onChangeFacet={onChangeFacet}
                        showMoreLimit={showMoreLimit}
                        expandByDefault={i === 0 ? true : fields.expandByDefault}
                        extendedStyles={productListCategoryFiltersStyles}
                    />
                ) : null,
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListAttributeFilters),
    definition: {
        group: "Product List",
        displayName: "Attribute Filters",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
